import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useMasksState = () => React.useContext(Context)
export const useMasks = () => useMasksState()?.mask

const QUERY = gql`
  query Mask($id: ID) {
    mask(id: $id, filter: { includeDisabled: true }) {
      id
      name
      pattern
      enabled
      deleted
      insertedAt
      updatedAt
    }
  }
`

const MasksLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: generalClient,
    skip: !id,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default MasksLoader
